import { Box, Grid, Stack } from "@mui/system";

import VerticalLinearStepper from "../VerticalLinearStepper";

import { RecapCard } from "../../RecapCard";
import { Alert, List, ListItem, Typography } from "@mui/material";
import { LiveCodeBlock } from "../../LiveCodeBlock";

export const KdappontLesson3 = () => {
  const subjectBlocks = [
    {
      label: "Links",
      main: (
        <>
          <LiveCodeBlock
            code={`<!DOCTYPE html>
  <html>
      <body>
        <a href="https://google.com" target="_blank">Link naar Google</a>

        <br/>

        <a href="/about.html">Link naar Over ons</a>

        <br/>

        <a href="#chapter4">Link naar Hoofdstuk 4</a>

        <div id="chapter4" style="margin: 2000px 0px">Hoofdstuk 4</div>
      </body>
  </html>`}
          />

          <br />

          <Stack direction="row" spacing={7}>
            <Box>
              <strong>target</strong>
              <List>
                <ListItem>_self (default)</ListItem>
                <ListItem>_blank</ListItem>
                <ListItem>_parent</ListItem>
              </List>
            </Box>

            <Box>
              <strong>href</strong>
              <List>
                <ListItem>Waar wil je naartoe?</ListItem>
                <ListItem>Intern, Extern, #</ListItem>
              </List>
            </Box>
          </Stack>
        </>
      ),
    },
    {
      label: "Images",
      main: (
        <>
          <LiveCodeBlock
            code={`<!DOCTYPE html>
  <html>
      <body>
          <img 
            src="/presentation-data/KDAPPONT2/intro/ai.jpeg" 
            alt="AI Bot"
            width="200px" 
            height="200px" />

          <img 
            src="https://picsum.photos/seed/picsum/400/200"
            alt="Berglandschap"
            />
      </body>
  </html>`}
          />

          <br />

          <Stack direction="row" spacing={7}>
            <Box>
              <strong>src</strong>
              <List>
                <ListItem>Lokaal</ListItem>
                <ListItem>Extern</ListItem>
              </List>
            </Box>
            <Box>
              <strong>width & height</strong>
              <List>
                <ListItem>in %</ListItem>
                <ListItem>in px</ListItem>
                <ListItem>... etc</ListItem>
              </List>
            </Box>
            <Box>
              <strong>alt (alternative)</strong>
              <List>
                <ListItem>beschrijvende tekst</ListItem>
              </List>
            </Box>
          </Stack>
        </>
      ),
    },
    {
      label: "Favicons",
      main: (
        <>
          <LiveCodeBlock
            code={`<!DOCTYPE html>
  <html>
      <head>
          <title>My Webpage</title>
          <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      </head>

      <body>
          <h1>Welkom</h1>
      </body>
  </html>`}
          />

          <br />

          <Stack direction="row" spacing={7}>
            <Box>
              <strong>rel (relationship)</strong>
              <List>
                <ListItem>icon</ListItem>
                <ListItem>stylesheet</ListItem>
                <ListItem>... etc</ListItem>
              </List>
            </Box>
            <Box>
              <strong>type</strong>
              <List>
                <ListItem>MIME-type</ListItem>
              </List>
            </Box>
            <Box>
              <strong>href</strong>
              <List>
                <ListItem>Locatie van het bestand</ListItem>
              </List>
            </Box>
          </Stack>
        </>
      ),
    },
    {
      label: "Tables",
      main: (
        <>
          <LiveCodeBlock
            code={`<table border="1">
    <thead>
        <tr>
            <th>Heading 1</th>
            <th>Heading 2</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Rij 1 - Kolom 1</td>
            <td>Rij 1 - Kolom 2</td>
        </tr>
        <tr>
            <td>Rij 2 - Kolom 1</td>
            <td>Rij 2 - Kolom 2</td>
        </tr>
    </tbody>
</table>`}
          />

          <br />

          <Stack direction="row" spacing={7}>
            <Box>
              <strong>thead</strong>
              <List>
                <ListItem>Table Head</ListItem>
              </List>
            </Box>
            <Box>
              <strong>tbody</strong>
              <List>
                <ListItem>Table Body</ListItem>
              </List>
            </Box>
            <Box>
              <strong>tr</strong>
              <List>
                <ListItem>Table Row</ListItem>
              </List>
            </Box>
            <Box>
              <strong>td</strong>
              <List>
                <ListItem>Table Data</ListItem>
              </List>
            </Box>
          </Stack>
        </>
      ),
    },
    {
      label: "Lists",
      main: (
        <>
          <LiveCodeBlock
            code={`<ul>
    <li>Item 1</li>
    <li>Item 2</li>
    <li>Item 3
        <ul>
            <li>Item 4</li>
        </ul>
    </li>
</ul>

<ol>
    <li>Item 1</li>
    <li>Item 2</li>
    <li>Item 3</li>
</ol>`}
          />
          <br />

          <strong>ul & ol</strong>
          <List>
            <ListItem>Unordered</ListItem>
            <ListItem>Ordered</ListItem>
          </List>
        </>
      ),
    },
    {
      label: "🏁",
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "👨🏼‍🏫 Voor vandaag - Les 3 & 4",
          description: `Praktijkvoorbeelden`,
          content: (
            <Grid container columns={4} spacing={2}>
              {subjectBlocks.map((subject) => (
                <Grid size={2} sx={{ "& > *": { height: "100%" } }}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },
        {
          label: "🚀 Digitaal Lesmateriaal - W3Schools - Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 1 :: HTML ➡️ LES 3 & LES4`,
          content: (
            <Alert severity="error" sx={{ alignItems: "center" }}>
              <Typography variant="h5">
                Maak uiteraard eerst je oefeningen en opdrachten van Les 2 af
              </Typography>
            </Alert>
          ),
        },
      ]}
    />
  );
};
